import { MeditatorTabs } from "@/constants";
import { cn } from "@/libs/cn";
import { Button } from "antd";
import { useLocation, useNavigate } from "react-router";

const Filters = [
    {
        title: "စာရင်းသွင်းထားသောယောဂီများ",
        value: MeditatorTabs.registered_meditators,
    },
    {
        title: "ယောဂီအသစ်စာရင်း",
        value: MeditatorTabs.new_registrants,
    },
    {
        title: "ယောဂီအဟောင်းစာရင်း",
        value: MeditatorTabs.old_registrants,
    }
]

export function MeditatorFilter({
    defaultActiveTab,
}: {
    defaultActiveTab?: keyof typeof MeditatorTabs;
}) {

    const searchParams = useLocation().search;
    const nav = useNavigate();

    const currentTab = new URLSearchParams(searchParams).get("tab") as string;

    const activeTab = defaultActiveTab ? defaultActiveTab :
        currentTab in MeditatorTabs ? currentTab :
            MeditatorTabs.registered_meditators;

    const onTabChange = (value: string) => {
        const params = new URLSearchParams(searchParams);
        params.set("tab", value);
        nav({
            pathname: `/retreat-registrants`,
            search: params.toString(),
        });
    }

    return (
        <div className="flex gap-2">
            {
                Filters.map(item => (
                    <Button
                        key={item.value}
                        onClick={() => onTabChange(item.value)}
                        type={activeTab === item.value ? "primary" : "default"}
                        className={cn(" active:!bg-transparent", {
                            "bg-primary-gradient": activeTab === item.value,
                            "hover:!text-f80 hover:!border-f80": activeTab !== item.value,
                        })}
                        shape="round"
                        size="large"
                    >
                        {item.title}
                    </Button>
                ))
            }
        </div>
    )
}
